import React, { useState, useEffect, useContext } from "react";
import { getToken } from "./auth";
import { AuthContext } from "./AuthProvider";
import AddUserModal from "./AddUserModal"; // ✅ import the new separate file
const BACKEND_URL = "https://parkengage.ai/api";

export default function AddQuestionModal({ onClose }) {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAddUser, setShowAddUser] = useState(false);
  const {  setToken } = useContext(AuthContext);
  const [role, setRole] = useState("");
  // const [password, setPassword] = useState("");

  const logout = () => {
    setToken(null);
    localStorage.removeItem("token");
    setShowAddUser(false);
    setQuestion("");
    setAnswer("");
    window.location.href = "/login";
  };

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/auth/me`, {
          headers: {
            "Content-Type": "application/json",
            ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
          },
        });
        if (res.ok) {
          const data = await res.json();
          setRole(data.role);
        }
      } catch (e) {
        console.error(e);
      }
    };
    fetchRole();
  }, []);

  const handleSubmit = async () => {
    if (!question.trim() || !answer.trim()) {
      alert("Both fields are required.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/add_qna`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
        },
        body: JSON.stringify({ question, answer }),
      });
      if (!res.ok) {
        // const err = await res.text();
        alert("Failed to save question.");
        setLoading(false);
        return;
      }
      await res.json();
      alert("✅ Saved successfully!");
      setQuestion("");
      setAnswer("");
      onClose();
    } catch (err) {
      console.error(err);
      alert("❌ Server not reachable.");
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white/90 border rounded-3xl shadow-2xl p-8 w-[90%] max-w-lg relative overflow-hidden">
        <h2 className="text-2xl font-semibold text-center mb-2">
          Add Knowledge
        </h2>
        <p className="text-center text-gray-500 text-sm mb-6">
          Provide a clear question and a helpful answer
        </p>

        <div className="space-y-4">
          <textarea
            placeholder="Enter Question..."
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg"
            rows={3}
          />
          <textarea
            placeholder="Enter Answer..."
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg"
            rows={3}
          />
        </div>

        <div className="flex justify-between items-center mt-6">
          {(role === "admin" || role === true) && (
            <button
              onClick={() => setShowAddUser(true)}
              className="py-2 px-4 rounded-lg bg-indigo-500 text-white"
            >
              + Add User
            </button>
          )}
          <div className="flex gap-3 ml-auto">
            <button onClick={logout} className="py-2 px-4 rounded-lg bg-gray-200">
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="py-2 px-4 rounded-lg bg-indigo-600 text-white"
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>

      {/* ✅ Use external AddUserModal now */}
      {showAddUser && (
        <AddUserModal
          onClose={() => setShowAddUser(false)}
          getToken={getToken}
          BACKEND_URL={BACKEND_URL}
        />
      )}
    </div>
  );
}
